import { jwtDecode, JwtPayload } from 'jwt-decode';

export interface TokenPayload extends JwtPayload {
    'https://hasura.io/jwt/claims': {
        'x-hasura-allowed-roles': string[];
        'x-hasura-default-role': string;
        'x-hasura-user-id': string;
        'x-hasura-provider-id'?: string;
        'x-hasura-role': string;
    };
    name: string;
}

export const getInitials = (name: string): string => {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const getUser = (token: string) => {
    const decoded: TokenPayload = jwtDecode(token);
    return {
        id: decoded['https://hasura.io/jwt/claims']['x-hasura-user-id'],
        name: decoded.name,
    };
};
